import CommonState from './CommonState'

/**
 * 海运出口相关常量
 *
 * @author Marco
 */

/**
 * 舱位状态
 */
export const WAITING_STATE = new CommonState(1, '未开始订舱', '')
export const BOOKING_FAIL_STATE = new CommonState(2, '订舱失败', '')
export const CONFIRM_STATE = new CommonState(3, '订舱待确认', '')
export const TO_BE_USE_STATE = new CommonState(4, '已订舱待使用', '')
export const GENERATED_STATE = new CommonState(5, '已生成业务', '')
export const BACK_STATE = new CommonState(6, '已退舱', '')
export const CABIN_STATE = new Set([
  WAITING_STATE,
  BOOKING_FAIL_STATE,
  CONFIRM_STATE,
  TO_BE_USE_STATE,
  GENERATED_STATE,
  BACK_STATE
])

export function getCabinStateName(state) {
  let stateName = ''
  for (const c of CABIN_STATE) {
    if (state === c.code) {
      stateName = c.chineseName
      break
    }
  }
  return stateName
}

// ------------
// 整箱类型
// ------------

export const FCL = new CommonState('FCL', '整箱', 'FCL')
export const LCL = new CommonState('LCL', '自拼箱', 'LCL')
export const BB = new CommonState('BB', '委托拼箱', 'BB')
export const BC = new CommonState('BC', 'Buyer Console', 'Buyer Console')
export const BULK = new CommonState('BULK', '散杂货', 'BULK Cargo')
export const SPA = new CommonState('SPA', '特种箱', 'Special')
export const BC_CARGO_TYPE_FCL = new CommonState('BCF', 'Buyer Console FCL', 'Buyer Console FCL')

export const CONTAINER_LOAD_TYPES = new Set([
  FCL,
  LCL,
  BB,
  BC,
  BULK,
  SPA,
  BC_CARGO_TYPE_FCL
])

export function getTypeName(typeValue) {
  let typeName = ''
  for (var c of CONTAINER_LOAD_TYPES) {
    if (typeValue === c.code) {
      typeName = c.chineseName
      break
    }
  }
  return typeName
}

export const STATE_VERIFYING = new CommonState(-1, '待审核', 'Pending')
export const STATE_OPERATING = new CommonState(0, '正操作', 'Operating')
export const STATE_COMMITED = new CommonState(1, '已提交', 'Committed')
export const STATE_VERIFIED = new CommonState(2, '已审核', 'Verified')
export const STATE_SHUT_OUT = new CommonState(3, '已退关', 'Shut Out')
export const STATE_PRE_COMMIT = new CommonState(11, '预提交', 'Pre Commit')
export const STATE_REJECT = new CommonState(12, '已拒绝', 'Reject')

export const STATE_TYPES = new Set([
  STATE_VERIFYING,
  STATE_OPERATING,
  STATE_COMMITED,
  STATE_VERIFIED,
  STATE_SHUT_OUT,
  STATE_PRE_COMMIT,
  STATE_REJECT
])

export const CHECK_STATE_TYPES = new Set([
  STATE_OPERATING,
  STATE_PRE_COMMIT,
  STATE_COMMITED,
  STATE_VERIFIED
])
// ------------
// 本地服务
// ------------

export const STUFFY_IS = new CommonState('IS', '内装箱', 'Inner Stuffing')
export const STUFFY_DD = new CommonState('DD', '门点装箱', 'Door to Door')
export const STUFFY_SD = new CommonState('SD', '自拉自送', 'Self Delivery')
export const STUFFY_CT = new CommonState('CT', '报关', 'Customs')
export const STUFFY_HT = new CommonState('HT', '熏蒸', 'Heating')
export const STUFFY_CIT = new CommonState('CIT', '商检', 'ComercialInspectation')
export const STUFFY_AMS = new CommonState('AMS', 'AMS', 'AMS/ENS')
export const STUFFY_ISBOOKING = new CommonState('ISBOOKING', '订舱', 'IsBooking')
export const STUFFY_BACK_UP_WAREHOUSE = new CommonState('BACK_UP_WAREHOUSE', '前置仓', 'Backup Warehouse')
export const STUFFY_TT = new CommonState('TT', '集卡拖车', 'Truck Trailer')
export const STUFFY_CL = new CommonState('CL', '整车/零担', 'WholeVehicle Less Than Carload')
export const STUFFY_IC = new CommonState('IC', '国际卡航', 'International Card Airlines')
export const STUFFY_MF = new CommonState('MF', 'Manifest', '预配舱单')
export const STUFFY_OT = new CommonState('OT', 'Other', '其他')

export const STUFFY_TYPES = new Set([
  STUFFY_IS,
  STUFFY_DD,
  STUFFY_SD,
  STUFFY_CT,
  STUFFY_HT,
  STUFFY_CIT,
  STUFFY_AMS,
  STUFFY_ISBOOKING,
  STUFFY_BACK_UP_WAREHOUSE,
  STUFFY_MF,
  STUFFY_OT
])

// 综合物流操作
export const INTEGRATED_TYPES = new Set([
  STUFFY_TT,
  STUFFY_CL,
  STUFFY_CT,
  STUFFY_IS,
  STUFFY_IC
])

// SOP 本地服务
export const SOP_STUFFY_TYPES = [
  STUFFY_IS,
  STUFFY_DD,
  STUFFY_SD,
  STUFFY_BACK_UP_WAREHOUSE
]

export const DESTINATION_AGENT_1 = new CommonState('1', '目的港清关', 'Customs clearance at the port of destination')
export const DESTINATION_AGENT_2 = new CommonState('2', '目的港派车', 'Dispatch vehicles at destination')
export const DESTINATION_AGENT_3 = new CommonState('3', '美国清关', 'US customs clearance')

/**
 * 目的港服务
 */
export const DESTINATION_TYPES = ([
  DESTINATION_AGENT_1,
  DESTINATION_AGENT_2,
  DESTINATION_AGENT_3
])

// ------------
// 约价性质
// ------------

/**
 * 自有约价(OS).Only for Sea.
 */
export const BOOKING_TERM_OS = new CommonState('OS', '自有约价', 'In-house pricing')
/**
 * 客户约价(CS).Only for Sea.
 */
export const BOOKING_TERM_CS = new CommonState('CS', '客户约价', 'Customer pricing')
/**
 * 海外代理约价(AS).Only for Sea.
 */
export const BOOKING_TERM_AS = new CommonState('AS', '海外代理约价', 'Overseas agent pricing')
/**
 * 无约价(NS).Only for Sea.
 */
export const BOOKING_TERM_NS = new CommonState('NS', '无约价', 'No pricing agreement')
/**
 * 同行约价(NS).Only for Sea.
 */
export const BOOKING_TERM_PS = new CommonState('PS', '同行约价', 'Peer pricing')
/**
 * AFC约价
 */
export const BOOKING_TERM_AFC = new CommonState('AFC', 'AFC约价', 'AFC pricing')
/**
 * AFG约价
 */
export const BOOKING_TERM_AFG = new CommonState('AFG', 'AFG约价', 'AFG pricing')

/**
 * 约价性质
 */
export const BOOKING_TERMS = new Set([
  BOOKING_TERM_OS,
  BOOKING_TERM_CS,
  BOOKING_TERM_AS,
  BOOKING_TERM_NS,
  BOOKING_TERM_PS,
  BOOKING_TERM_AFC,
  BOOKING_TERM_AFG
])

/**
 * 适用品名
 * @type {CommonState}
 */
// 普通货物(FAK - Freight All Kinds)
export const PRODUCT_FAK = new CommonState('FAK', '普通货物', 'General cargo (FAK)')

// 危险品
export const PRODUCT_DG = new CommonState('DG', '危险品', 'Dangerous goods')

// 特种柜
export const PRODUCT_OG = new CommonState('OG', '特种柜', 'Special equipment')

// 冷冻柜
export const PRODUCT_RF = new CommonState('RF', '冷冻柜', 'Reefer container')

// 化工品
export const PRODUCT_CHEM = new CommonState('CHEM', '化工品', 'Chemical products')

// 纺织品
export const PRODUCT_TEXTILE = new CommonState('TEXTILE', '纺织品', 'Textile products')

// 其他
export const PRODUCT_OTHER = new CommonState('OTHER', '其他', 'Other cargo')

export const PRODUCT_NAMES = new Set([
  PRODUCT_FAK,
  PRODUCT_DG,
  PRODUCT_OG,
  PRODUCT_RF,
  PRODUCT_CHEM,
  PRODUCT_TEXTILE,
  PRODUCT_OTHER
])
// 舱保单位
export const CABIN_UNIT_TEU_WEEK = new CommonState('TEU_WEEK', 'TEU/周', 'TEU/Week')
export const CABIN_UNIT_TEU_WATER = new CommonState('TEU_WATER', 'TEU/水', 'TEU/Water')
export const CABIN_UNIT_TEU_CONTRACT = new CommonState('TEU_CONTRACT', 'TEU/合约期', 'TEU/Contract Period')
export const CABIN_UNIT_TEU_MONTH = new CommonState('TEU_MONTH', 'TEU/月', 'TEU/Month')
export const CABIN_UNIT_TEU_YEAR = new CommonState('TEU_YEAR', 'TEU/年', 'TEU/Year')

export const CABIN_UNIT_NAMES = new Set([
  CABIN_UNIT_TEU_WEEK,
  CABIN_UNIT_TEU_WATER,
  CABIN_UNIT_TEU_CONTRACT,
  CABIN_UNIT_TEU_MONTH,
  CABIN_UNIT_TEU_YEAR
])

export const CUSTOMS_TRANSIT = new CommonState(1, '转关', 'Transit')
export const CUSTOMS_CLEARANCE = new CommonState(2, '清关', 'clearance')

export const DECLARE_CUSTOMS_TYPES = new Set([
  CUSTOMS_TRANSIT,
  CUSTOMS_CLEARANCE
])

// ------------
// 跨tenant委托状态(委托方)
// ------------
/**
 * 我方已送达
 */
export const CROSS_TENANT_DELIVERY = new CommonState(0, '我方已送达', 'Delivery')
/**
 * 对方已查看
 */
export const CROSS_TENANT_LOOKOVER = new CommonState(1, '对方已查看', 'Look over')
/**
 * 对方已拒绝
 */
export const CROSS_TENANT_REFUSED = new CommonState(2, '对方已拒绝', 'Refused')
/**
 * 对方已受理
 */
export const CROSS_TENANT_ACCEPTED = new CommonState(3, '对方已受理', 'Accepted')
/**
 * 配舱已完成
 */
export const CROSS_TENANT_FINISHED = new CommonState(4, '配舱已完成', 'Finished')

/**
 * 数据被修改
 */
export const CROSS_TENANT_MODIFIED = new CommonState(5, '数据被修改', 'Modified')

export const CROSS_TENANT_HISTORY_STATES = new Set([
  CROSS_TENANT_DELIVERY,
  CROSS_TENANT_LOOKOVER,
  CROSS_TENANT_REFUSED,
  CROSS_TENANT_ACCEPTED,
  CROSS_TENANT_FINISHED
])

// ------------
// 跨tenant委托状态(接收方)
// ------------
/**
 * 对方已送达
 */
export const CROSS_TENANT_DELIVERY_RECEIVER = new CommonState(0, '对方已送达', 'Delivery')
/**
 * 我方已查看
 */
export const CROSS_TENANT_LOOKOVER_RECEIVER = new CommonState(1, '我方已查看', 'Look over')
/**
 * 我方已拒绝
 */
export const CROSS_TENANT_REFUSED_RECEIVER = new CommonState(2, '我方已拒绝', 'Refused')
/**
 * 我方已受理
 */
export const CROSS_TENANT_ACCEPTED_RECEIVER = new CommonState(3, '我方已受理', 'Accepted')
/**
 * 配舱已完成
 */
export const CROSS_TENANT_FINISHED_RECEIVER = new CommonState(4, '配舱已完成', 'Finished')
/**
 * 数据被修改
 */
export const CROSS_TENANT_MODIFIED_RECEIVER = new CommonState(5, '数据被修改', 'Modified')

export const CROSS_TENANT_HISTORY_STATES_RECEIVER = new Set([
  CROSS_TENANT_DELIVERY_RECEIVER,
  CROSS_TENANT_LOOKOVER_RECEIVER,
  CROSS_TENANT_REFUSED_RECEIVER,
  CROSS_TENANT_ACCEPTED_RECEIVER,
  CROSS_TENANT_FINISHED_RECEIVER
])

// ------------
// CONTAINER 箱属类型
// ------------
export const CONTAINER_ASCRIPTION_COC = new CommonState('COC', 'COC', 'COC')
export const CONTAINER_ASCRIPTION_SOC = new CommonState('SOC', 'SOC', 'SOC')

export const CONTAINER_ASCRIPTION_SOC_STATE = new CommonState(1, 'SOC', 'SOC')
export const CONTAINER_ASCRIPTION_COC_STATE = new CommonState(0, 'COC', 'COC')

export const CONTAINER_ASCRIPTION_TYPE = new Set([
  CONTAINER_ASCRIPTION_COC,
  CONTAINER_ASCRIPTION_SOC
])

export const CONTAINER_ASCRIPTION_STATES = new Set([
  CONTAINER_ASCRIPTION_SOC_STATE,
  CONTAINER_ASCRIPTION_COC_STATE
])

// 温度单位
export const TEMP_UNIT_CEL = new CommonState('CEL', 'CEL', 'CEL')
export const TEMP_UNIT_FAH = new CommonState('FAH', 'FAH', 'FAH')

export const REEF_TEMP_UNIT = new Set([
  TEMP_UNIT_CEL,
  TEMP_UNIT_FAH
])

export const REEF_TEMP_UNITS = [TEMP_UNIT_CEL, TEMP_UNIT_FAH]

//  通风量单位
export const VENTILATION_CBM = new CommonState('CBM/H', 'CBM/H', 'CBM/H')
export const VENTILATION_CFM = new CommonState('CFM/H', 'CFM/H', 'CFM/H')

export const VENTILATION_UNIT = new Set([
  VENTILATION_CBM,
  VENTILATION_CFM
])

//  船公司约号单位 RFA TAA SC
export const TYPE_RFA = new CommonState('RFA', 'RFA', 'RFA')
export const TYPE_TAA = new CommonState('TAA', 'TAA', 'TAA')
export const TYPE_SC = new CommonState('SC', 'SC', 'SC')

export const SC_NO_TYPES = new Set([TYPE_RFA, TYPE_TAA, TYPE_SC])

// 危险品形态
export const HAZARD_FORM_GAS = new CommonState('GAS', 'GAS', 'GAS')
export const HAZARD_FORM_LIQUID = new CommonState('LIQUID', 'LIQUID', 'LIQUID')
export const HAZARD_FORM_SOLID = new CommonState('SOLID', 'SOLID', 'SOLID')

export const HAZARD_FORM_ARR = [HAZARD_FORM_GAS, HAZARD_FORM_LIQUID, HAZARD_FORM_SOLID]

export const DEVICE_STATE_NEW = new CommonState(0, '全新', 'NEW')
export const DEVICE_STATE_USE = new CommonState(1, '二手', 'USE')
export const DEVICE_STATE_TYPE = new Set([DEVICE_STATE_USE, DEVICE_STATE_NEW])

// 审核状态
export const AUDIT_NOT = new CommonState(0, '未审核', 'Unaudited')
export const AUDIT_WAIT = new CommonState(1, '待审核', 'Pending')
export const AUDIT_AGREE = new CommonState(2, '已同意', 'Agree')
export const AUDIT_REFUSE = new CommonState(3, '已拒绝', 'Refuse')
export const AUDIT_STATES_LIST = new Set([AUDIT_NOT, AUDIT_WAIT, AUDIT_AGREE, AUDIT_REFUSE])

// 签约状态
export const CONTRACT_STATE_NO = new CommonState(0, '未签约', 'No Contract')
export const CONTRACT_STATE_OUT_OF_DATE = new CommonState(1, '合约失效', 'Out of date')
export const CONTRACT_STATE_SIGNED = new CommonState(2, '已签约', 'Contract Signed')

export const CONTRACT_STATE_LIST = new Set([CONTRACT_STATE_NO, CONTRACT_STATE_OUT_OF_DATE, CONTRACT_STATE_SIGNED])

// ------------
// 除收发通以外的类型
// ------------
export const ALSO_NOTIFY = new CommonState('ALSO NOTIFY', 'ALSO NOTIFY', 'ALSO NOTIFY')
export const DGCONSIGN = new CommonState('DGCONSIGN', 'DGCONSIGN', 'DGCONSIGN')
export const ELSE_INVOICE = new CommonState('ELSEINVOICE', 'ELSEINVOICE', 'ELSEINVOICE')
export const OTHER_INFO = new Set([
  ALSO_NOTIFY,
  DGCONSIGN,
  ELSE_INVOICE
])

export const FNL_TM_TRUCK = new CommonState('TRK', 'Truck', 'Truck')
export const FNL_TM_BARGE = new CommonState('BRG', 'Barge', 'Barge')
export const FNL_TM_RAIL = new CommonState('RAL', 'Rail', 'Rail')
export const FNL_TM = new Set([
  FNL_TM_TRUCK,
  FNL_TM_BARGE,
  FNL_TM_RAIL
])

// Msc FNL_TM
export const MSC_FNL_TM_TRUCK = new CommonState('TRK', 'Truck', 'Truck')
export const MSC_FNL_TM_BARGE = new CommonState('BRG', 'Barge', 'Barge')
export const MSC_FNL_TM_RAIL = new CommonState('RAL', 'Rail', 'Rail')
export const MSC_FNL_TM = new Set([
  MSC_FNL_TM_TRUCK,
  MSC_FNL_TM_BARGE,
  MSC_FNL_TM_RAIL
])

// MSC 拆分类型
export const MSC_SPLIT_TYPE_DEFAULT = new CommonState(0, 'Default', 'Default')
export const MSC_SPLIT_TYPE_COMBINE = new CommonState(4, 'Combine', 'Combine')
export const MSC_SPLIT_TYPE_OTHER = new CommonState(1, 'Other', 'Other')
export const MSC_SPLIT_TYPE_PARTLOAD = new CommonState(3, 'Partload', 'Partload')
export const MSC_SPLIT_TYPE_SPLIT = new CommonState(2, 'Split', 'Split')
export const MSC_SPLIT_TYPES = new Set([
  MSC_SPLIT_TYPE_COMBINE,
  MSC_SPLIT_TYPE_OTHER,
  MSC_SPLIT_TYPE_PARTLOAD,
  MSC_SPLIT_TYPE_SPLIT
])

// MSC 签约类型
export const MSC_CONTRACT_TYPE_GENERAL = new CommonState(1, 'General Tariff', 'General Tariff')
export const MSC_CONTRACT_TYPE_TARIFF = new CommonState(2, 'Rate Agreement', 'Rate Agreement')
export const MSC_CONTRACT_TYPE_AGREEMENT = new CommonState(3, 'Service Contract Number', 'Service Contract Number')
export const MSC_CONTRACT_TYPE_QUOTATION = new CommonState(4, 'Spot Quotation', 'Spot Quotation')
export const MSC_CONTRACT_TYPES = new Set([
  MSC_CONTRACT_TYPE_GENERAL,
  MSC_CONTRACT_TYPE_TARIFF,
  MSC_CONTRACT_TYPE_AGREEMENT,
  MSC_CONTRACT_TYPE_QUOTATION
])

// MSC 提单方式
export const MSC_ORIGINAL = new CommonState(0, 'ORIGINAL', 'ORIGINAL')
export const MSC_CONTRACT_SEAWAY = new CommonState(1, 'SEAWAY', 'SEAWAY')
export const MSC_BILLTYPES = new Set([
  MSC_ORIGINAL,
  MSC_CONTRACT_SEAWAY
])

/**
 * 互联派车费用状态
 */
export const COST_STATUS_NO_CONFIRM = new CommonState('3', '未确认', 'Unconfirmed')
export const COST_STATUS_WAIT_CONFIRM = new CommonState('0', '待确认', 'To be confirmed')
export const COST_STATUS_CONFIRM = new CommonState('1', '已确认', 'Confirmed')
export const COST_STATUS_RETURNED = new CommonState('2', '已退回', 'Has been returned')
export const COST_STATUS = new Set([
  COST_STATUS_NO_CONFIRM,
  COST_STATUS_WAIT_CONFIRM,
  COST_STATUS_CONFIRM,
  COST_STATUS_RETURNED
])
/**
 * 互联派车状态
 */
export const TRUCKING_UN_DISPATCHED = new CommonState('00', '未派单', 'UnDispatched')
export const TRUCKING_UN_APPROVED = new CommonState('01', '待审核-未接单', 'UnApproved')
export const TRUCKING_RECEIVED = new CommonState('02', '待分配车辆-已接单', 'Received')
export const TRUCKING_ORDER_REFUSED = new CommonState('03', '拒绝接单', 'OrderRefused')
export const TRUCKING_DISPATCHED = new CommonState('04', '待提柜-已派车', 'Dispatched')
export const TRUCKING_REFUSED = new CommonState('05', '拒绝派车', 'Refused')
export const TRUCKING_EXHAUST = new CommonState('06', '待过磅-已提空', 'Exhausted')
export const TRUCKING_ARRIVED = new CommonState('07', '已到厂', 'Arrived')
export const TRUCKING_LEAVED = new CommonState('08', '待还柜进港-已离厂', 'Leaved')
export const TRUCKING_FINISHED = new CommonState('09', '已完成', 'Finished')
export const TRUCKING_PASS_BACK = new CommonState('10', '已回传', 'PassBack')
export const TRUCKING_ORDER_CANCELED = new CommonState('11', '已撤单', 'OrderCanceled')
export const TRUCKING_ORDER_CANCELING = new CommonState('12', '撤单中', 'OrderCanceling')

export const TRUCKING_ORDER_CUSTOMER_NOT_EXSISTS = new CommonState('2001', '客户不存在', '客户不存在')
export const TRUCKING_ORDER_ORDERNO_UN_UNIQUE = new CommonState('2002', '票号不唯一', '票号不唯一')
export const TRUCKING_ORDER_CONTAINER_REPET = new CommonState('2003', '箱序号有重复', '箱序号有重复')
export const TRUCKING_ORDER_DATA_EXCEPTION = new CommonState('2004', '处理数据异常', '处理数据异常')
export const TRUCKING_ORDER_TRUCKING_NOT_EXSISTS = new CommonState('2005', '指派车队不存在', '指派车队不存在')
export const TRUCKING_ORDER_ORDER_NOT_EXSISTS = new CommonState('2006', '票信息不存在', '票信息不存在')
export const TRUCKING_ORDER_CONTAINER_NOT_EXSISTS = new CommonState('2007', '箱信息不存在', '箱信息不存在')
export const TRUCKING_ORDER_SOP_NOT_EXSISTS = new CommonState('2008', '无派车流程节点，无法自动派单', '无派车流程节点，无法自动派单')
export const TRUCKING_ORDER_DISTATCHING = new CommonState('2009', '派单中，指派车队不能更改', '派单中，指派车队不能更改')
export const TRUCKING_ORDER_TRUCK_REQUIRE = new CommonState('2010', '指派车队必填', '指派车队必填')
export const TRUCKING_ORDER_NOT_REVOKE = new CommonState('2011', '不可撤单状态', '不可撤单状态')
export const TRUCKING_ORDER_NOT_BINDING = new CommonState('2012', '没有此绑定车队请求', '没有此绑定车队请求')
export const TRUCKING_ORDER_INTERFACE_NOT_ACCESS = new CommonState('2013', '接口权限未开通', '接口权限未开通')
export const TRUCKING_ORDER_TRUCK_SUPPLIED = new CommonState('2014', '已经申请绑定此车队', '已经申请绑定此车队')
export const TRUCKING_ORDER_TRUCK_GET_FAILED = new CommonState('2015', '获取车队信息失败', '获取车队信息失败')
export const TRUCKING_ORDER_NOT_BINDING_YET = new CommonState('2016', '暂无绑定协议车队', '暂无绑定协议车队')
export const TRUCKING_ORDER_NOT_ARRAY = new CommonState('2017', '数据组 id 未指定', '数据组 id 未指定')
export const TRUCKING_ORDER_NOT_USER = new CommonState('2018', '互联派车无此用户', '互联派车无此用户')
export const TRUCKING_ORDER_USER_NOT_UNIQUE = new CommonState('2019', '互联派车用户姓名不唯一', '互联派车用户姓名不唯一')
export const TRUCKING_ORDER_REVOKE_REFUSED = new CommonState('3000', '撤单-拒绝接单', '撤单-拒绝接单')
export const TRUCKING_ORDER_SAVED_DRIVER_INFO = new CommonState('3001', '保存接单司机信息', '保存接单司机信息')
export const TRUCKING_ORDER_TRUCK_UPDATED = new CommonState('3002', '更新派车单状态', '更新派车单状态')
export const TRUCKING_ORDER_BOX_NO_SAVED = new CommonState('3003', '保存柜封号信息', '保存柜封号信息')

export const TRUCKING_ORDER_STATUS = new Set([
  TRUCKING_UN_DISPATCHED,
  TRUCKING_UN_APPROVED,
  TRUCKING_RECEIVED,
  TRUCKING_ORDER_REFUSED,
  TRUCKING_DISPATCHED,
  TRUCKING_REFUSED,
  TRUCKING_EXHAUST,
  TRUCKING_ARRIVED,
  TRUCKING_LEAVED,
  TRUCKING_FINISHED,
  TRUCKING_PASS_BACK,
  TRUCKING_ORDER_CANCELED,
  TRUCKING_ORDER_CANCELING,
  TRUCKING_ORDER_CUSTOMER_NOT_EXSISTS,
  TRUCKING_ORDER_ORDERNO_UN_UNIQUE,
  TRUCKING_ORDER_CONTAINER_REPET,
  TRUCKING_ORDER_DATA_EXCEPTION,
  TRUCKING_ORDER_TRUCKING_NOT_EXSISTS,
  TRUCKING_ORDER_ORDER_NOT_EXSISTS,
  TRUCKING_ORDER_CONTAINER_NOT_EXSISTS,
  TRUCKING_ORDER_SOP_NOT_EXSISTS,
  TRUCKING_ORDER_DISTATCHING,
  TRUCKING_ORDER_TRUCK_REQUIRE,
  TRUCKING_ORDER_NOT_REVOKE,
  TRUCKING_ORDER_NOT_BINDING,
  TRUCKING_ORDER_INTERFACE_NOT_ACCESS,
  TRUCKING_ORDER_TRUCK_SUPPLIED,
  TRUCKING_ORDER_TRUCK_GET_FAILED,
  TRUCKING_ORDER_NOT_BINDING_YET,
  TRUCKING_ORDER_NOT_ARRAY,
  TRUCKING_ORDER_NOT_USER,
  TRUCKING_ORDER_USER_NOT_UNIQUE,
  TRUCKING_ORDER_REVOKE_REFUSED,
  TRUCKING_ORDER_SAVED_DRIVER_INFO,
  TRUCKING_ORDER_TRUCK_UPDATED,
  TRUCKING_ORDER_BOX_NO_SAVED
])

// 集装箱动态轨迹查询 箱子行踪
export const STATUS_ALL = new CommonState(0, '全部', 'All')
export const DEPARTURE_CABINET = new CommonState(1, '出发提柜', 'DepartureCabinet')
export const BE_PRESENT = new CommonState(2, '到厂', 'Be present')
export const DEPARTURE = new CommonState(3, '离厂', 'Departure')
export const ENTER_THE_WHARF = new CommonState(4, '进码头', 'Enter the wharf')
export const CUSTOMS_RELEASE = new CommonState(5, '海关放行', 'Customs release')
export const WHARF_RELEASE = new CommonState(6, '码头放行', 'Wharf Release')
export const ABOARD = new CommonState(7, '上船', 'Aboard')
export const ARRIVAL_TIME = new CommonState(8, '到港', 'Arrival Time')
export const CUSTOMS_CLEARANCES = new CommonState(9, '目的港放关', 'Customs Clearance')
export const DELIVERY_TIME = new CommonState(10, '送货', 'Delivery Time')
export const RETURN_TIME = new CommonState(11, '还箱', 'Return Time')
export const DEPARTURE_FROM = new CommonState(12, '离港', 'departure From')

export const WHEREABOUTS_TYPES = new Set([
  STATUS_ALL,
  DEPARTURE_CABINET,
  BE_PRESENT,
  DEPARTURE,
  ENTER_THE_WHARF,
  CUSTOMS_RELEASE,
  WHARF_RELEASE,
  ABOARD,
  ARRIVAL_TIME,
  CUSTOMS_CLEARANCES,
  DELIVERY_TIME,
  RETURN_TIME,
  DEPARTURE_FROM
])

// 集装箱动态轨迹查询 行驶状态
export const TR_PARKING = new CommonState(1, '停车', 'Parking')
export const TR_IN_MOTION = new CommonState(2, '行驶中', 'InMotion')
export const TR_ARRIVED = new CommonState(3, '已到达', 'Arrived')
export const TR_TYPES = new Set([
  TR_PARKING,
  TR_IN_MOTION,
  TR_ARRIVED
])

// HBL提单类型 （TH 同行 WT 委托）
export const HBL_TH = new CommonState('TH', '同行', 'TH')
export const HBL_WT = new CommonState('WT', '委托', 'WT')
export const HBL_TYPES = new Set([
  HBL_TH,
  HBL_WT
])

// 集装箱动态轨迹查询 状态
export const TR_All = new CommonState(1, '全部', 'All')
export const TR_ABNORMAL = new CommonState(2, '异常', 'Abnormal')
export const TR_NORMAL = new CommonState(3, '正常', 'Normal')
export const TR_DONE = new CommonState(4, '已完成', 'Done')
export const TR_STATUS = new Set([
  TR_All,
  TR_ABNORMAL,
  TR_DONE,
  TR_NORMAL
])

// ------------
// 按钮
// ------------
// 新增
export const BUTTON_ADD = new CommonState('Add', '新增', 'Add')
export const BUTTON_IMPORTTOPDF = new CommonState('ImportToPDF', 'PDF导入', 'ImportToPDF')
export const BUTTON_ADDHBL = new CommonState('AddHbl', '新增主票', 'AddHbl')
export const BUTTON_CLONE = new CommonState('Clone', '复制', 'Clone')

// 批量操作
export const BUTTON_ADD_CHARGES = new CommonState('AddCharges', '新增费用', 'AddCharges')
export const BUTTON_CHARGE_IMPORT = new CommonState('ChargeImport', '费用导入', 'ChargeImport')
export const BUTTON_EDIT_CHARGES = new CommonState('AddCharges', '编辑费用', 'EditCharges')
export const BUTTON_DELETE_CHARGES = new CommonState('ChargeImport', '删除费用', 'DeleteCharges')

export const BUTTON_BATCH_VESSEL = new CommonState('BatchVessel', '批量转船', 'BatchVessel')
export const BUTTON_EDIT_SOP_STATUS = new CommonState('EditSopStatus', '状态修改', 'EditSopStatus')
export const BUTTON_BATCH_UPDATETYPE = new CommonState('BatchUpdateType', '批量修改整拼类型', 'BatchUpdateType')

export const BUTTON_BATCH_SHUTOUT = new CommonState('BatchShutOut', '批量退关', 'BatchShutOut')
export const BUTTON_BATCH_COMMIT = new CommonState('BatchCommit', '批量提交', 'BatchCommit')

export const BUTTON_BATCH_PRINT = new CommonState('BatchPrint', '批量打印', 'BatchPrint')

// 打印
export const BUTTON_PRINT = new CommonState('Print', '打印', 'Print')
export const BUTTON_PRINT_FCLPROFIT = new CommonState('PrintFclProfit', '整箱利润打印', 'PrintFclProfit')
export const BUTTON_PRINT_LCLPROFIT = new CommonState('PrintLclProfit', '拼箱利润打印', 'PrintLclProfit')

// 流程
export const BUTTON_SUBMISSION = new CommonState('Submission', '提交', 'Submission')
export const BUTTON_SHUTOUT = new CommonState('ShutOut', '退关', 'ShutOut')
export const BUTTON_CANCEL_SHUTOUT = new CommonState('CancelShutOut', '取消退关', 'CancelShutOut')
export const BUTTON_PRINT_RETURN = new CommonState('PrintReturn', '撤回', 'PrintReturn')

export const CHILD_NO_LETTER = new CommonState('childNoLetter', '字母后缀', '')
export const CHILD_NO_LETTER_FRIENDLY = new CommonState('childNoLetterFriendly', '字母后缀（不含I和O）', '')
export const CHILD_NO_NUMBER = new CommonState('childNoNumber', '数字后缀', '')
export const CHILD_NO_EXTENSION = new CommonState('childNoExtension', '主单号顺延', '')

export const SO_NO_RULE_TYPES = new Set([
  CHILD_NO_LETTER,
  CHILD_NO_LETTER_FRIENDLY,
  CHILD_NO_NUMBER,
  CHILD_NO_EXTENSION
])

export const SPILT_CHARS = ['-', '*']

/**
 * 集装箱状态
 */
export const LOADING_STATE = new CommonState(0, '计划中', 'Planning')
export const LOCK_STATE = new CommonState(1, '已锁定', 'Locked')
export const DONE_STATE = new CommonState(2, '已装箱', 'Boxed')
export const CONTAINER_STATE = [
  LOADING_STATE,
  LOCK_STATE,
  DONE_STATE
]

/**
 * 放行配载状态
 * 海关已放行、码头已放行、码头已配载。（分别取值海关放行、码头放行、码头配载为Y的业务）
 * */
export const WHARF_RELEASE_STATE = new CommonState(1, '码头已放行', 'The dock has been released')
export const CUSTOM_RELEASE_STATE = new CommonState(2, '海关已放行', 'Customs clearance')
export const WHARF_STOWAGE_STATE = new CommonState(3, '码头已配载', 'Dock stowed')
export const RELEASE_STOWAGE_STATE = new Set([
  WHARF_RELEASE_STATE,
  CUSTOM_RELEASE_STATE,
  WHARF_STOWAGE_STATE
])

/**
 * 海关放行、码头配载 状态 Y  N
 * */
export const RELEASE_STOWAGE_STATE_Y = new CommonState('Y', 'Y', 'Y')
export const RELEASE_STOWAGE_STATE_N = new CommonState('N', 'N', 'N')
export const RELEASE_STOWAGE_STATE_Y_N = [
  RELEASE_STOWAGE_STATE_Y,
  RELEASE_STOWAGE_STATE_N
]

/**
* 码头放行 状态 Y  N  R
* */
export const WHARF_RELEASE_STATE_Y = new CommonState('Y', 'Y', 'Y')
export const WHARF_RELEASE_STATE_N = new CommonState('N', 'N', 'N')
export const WHARF_RELEASE_STATE_R = new CommonState('R', 'R', 'R')
export const WHARF_RELEASE_STATE_Y_N_R = [
  WHARF_RELEASE_STATE_Y,
  WHARF_RELEASE_STATE_N,
  WHARF_RELEASE_STATE_R
]

/**
 * 预配信息 重量单位 总重量单位 提交单位 箱皮重单位
 * */
export const KGS = new CommonState('KGS', 'KGS', 'KGS')
export const LBS = new CommonState('LBS', 'LBS', 'LBS')
export const TONS = new CommonState('TONS', 'TONS', 'TONS')
export const WEIGHT_UNIT = [KGS, LBS, TONS]

/**
 * 预配信息 货物 体积单位
 * */
export const CBM = new CommonState('CBM', 'CBM', 'CBM')
export const CFT = new CommonState('CFT', 'CFT', 'CFT')
export const CUBAGE_UNIT = [CBM, CFT]

export const TRUCKING_INFO_TYPE_DTD = new CommonState(1, '门到门', 'Door To Door')
export const TRUCKING_INFO_TYPE_DTW = new CommonState(2, '门到仓', 'Door To Warehouse')
export const TRUCKING_INFO_TYPE_WTD = new CommonState(3, '仓到门', 'Warehouse To Door')
export const TRUCKING_INFO_TYPES = [TRUCKING_INFO_TYPE_DTD, TRUCKING_INFO_TYPE_DTW, TRUCKING_INFO_TYPE_WTD]

export const VGM_CHANNEL_SEA_HOUSE = new CommonState(1, '海管家发送', 'Sea house send')
export const VGM_CHANNEL_DEFAULT = new CommonState(0, '仅信息保存', 'Only save')
export const VGM_CHANNEL_WSE = new CommonState(2, '未斯发送', 'Wse send')
export const VGM_CHANNEL_RONGE_TONG = new CommonState(3, '荣e通发送', 'rongeTong send')
export const VGM_CARGOWARE = new CommonState(1, 'Cargoware发送', 'Cargoware send')
/**
 * VGM通道
 * @type {CommonState[]}
 */
export const VGM_CHANNELS = [VGM_CARGOWARE, VGM_CHANNEL_DEFAULT]

/**
 * 发送渠道
 */
export const SEND_CHANNEL_SEA_HOUSE = new CommonState(1, '海管家', 'Sea house')
export const SEND_CHANNEL_WSE = new CommonState(2, '未斯', 'Wse')
export const SEND_CHANNEL_RONGE_TONG = new CommonState(3, '荣e通', 'rongeTong')

export const SEND_CHANNELS = [SEND_CHANNEL_SEA_HOUSE, SEND_CHANNEL_WSE]

export const BOX_HOLDER_COC = new CommonState('COC', 'COC船公司自有箱', 'COC shipping company owns its own boxes')
export const BOX_HOLDER_SOC = new CommonState('SOC', 'SOC货主自有箱', 'SOC shippers own their own boxes')
/**
 * 持箱人
 * @type {CommonState[]}
 */
export const BOX_HOLDERS = [BOX_HOLDER_COC, BOX_HOLDER_SOC]

export const VGM_SEND_CHANNEL_ALL = new CommonState(0, '全部', 'all')
export const VGM_SEND_CHANNEL_SHIPPING_COMPANY = new CommonState(1, '船公司VGM', 'Shipping company vgm')
export const VGM_SEND_CHANNEL_CLOUD_PORT_PASS = new CommonState(2, '云港通VGM', 'Cloud Port Pass vgm')
export const VGM_SEND_CHANNELS = [VGM_SEND_CHANNEL_ALL, VGM_SEND_CHANNEL_SHIPPING_COMPANY, VGM_SEND_CHANNEL_CLOUD_PORT_PASS]

export const VGM_RECEIPT_RECEPTION = new CommonState('1', '接收', 'reception')
export const VGM_RECEIPT_REFUSE = new CommonState('2', '拒绝', 'refuse')
export const VGM_RECEIPT_CHARGEBACKS = new CommonState('3', '退单', 'Chargebacks')
export const VGM_WSE_WAITING = new CommonState('0', '发送中', 'WAITING')
export const VGM_RECEIPT_FAILURE = new CommonState('4', '发送失败', 'Failure')
export const VGM_WSE_SEND_SUCCESS = new CommonState('99', '发送成功', 'SEND_SUCCESS')
export const VGM_WSE_SEND_FAILURE = new CommonState('102', '发送失败', 'SEND_FAILURE')
export const VGM_WSE_REPLY_SUCCESS = new CommonState('100', '回执成功', 'REPLY_SUCCESS')
export const VGM_WSE_REPLY_FAILURE = new CommonState('101', '回执失败', 'REPLY_FAILURE')
/**
 * VGMh回执状态
 * @type {CommonState[]}
 */
export const VGM_RECEIPTS = [VGM_RECEIPT_RECEPTION, VGM_RECEIPT_REFUSE, VGM_RECEIPT_CHARGEBACKS, VGM_WSE_WAITING, VGM_WSE_SEND_SUCCESS, VGM_WSE_SEND_FAILURE, VGM_WSE_REPLY_SUCCESS, VGM_WSE_REPLY_FAILURE, VGM_RECEIPT_FAILURE]

export const VGM_YGT_STATE_CONFIRM = new CommonState(2, '确认成功', 'SEND_SUCCESS')
export const VGM_YGT_STATE_SUCCESS = new CommonState(1, '发送成功', 'SEND_FAILURE')
export const VGM_YGT_STATE_FAILURE = new CommonState(3, '发送失败', 'REPLY_SUCCESS')
export const VGM_YGT_STATE_REFUSE = new CommonState(4, '场站拒绝', 'REPLY_FAILURE')
export const VGM_YGT_STATES = [VGM_YGT_STATE_CONFIRM, VGM_YGT_STATE_SUCCESS, VGM_YGT_STATE_FAILURE, VGM_YGT_STATE_REFUSE]

export const NOT_SENT = new CommonState('0', '未发送', 'Not sent')
export const SENT = new CommonState('1', '已发送', 'Sent')
/**
 * 预配状态
 * @type {CommonState[]}
 */
export const PROVISIONING_STATUS = [NOT_SENT, SENT]

export const CARGO_OWNER_SOC = new CommonState(1, '货主SOC', 'Cargo Owner SOC')
export const FORWARDER_SOC = new CommonState(2, '货代SOC', 'Forwarder SOC')

/**
 * 箱型
 */
export const BOX_TYPE_20 = new CommonState('20', "20'", "20'")
export const BOX_TYPE_40 = new CommonState('40', "40'", "40'")
export const BOX_TYPE_45 = new CommonState('45', "45'", "45'")
export const BOX_TYPE_10 = new CommonState('10', "10'", "10'")
export const BOX_TYPE_53 = new CommonState('53', "53'", "53'")
export const BOX_TYPE_30 = new CommonState('30', "30'", "30'")
export const BOX_TYPE_48 = new CommonState('48', "48'", "48'")

/**
 * 海运取值
 */
export const SEA_EXPORT_BOX_TYPES = [
  BOX_TYPE_20,
  BOX_TYPE_40,
  BOX_TYPE_45,
  BOX_TYPE_10,
  BOX_TYPE_53,
  BOX_TYPE_30,
  BOX_TYPE_48
]

// 销售查询统计
export const BOX_TYPE_40HQ = new CommonState('40HQ', "40HQ'", "40HQ'")

export const SOC_TYPE = new Set([
  CARGO_OWNER_SOC,
  FORWARDER_SOC
])

/**
 * 欧线ENS申报标识
 */
export const ENS_DECLARATION_S = new CommonState('S', 'S:Self (Manifest Type(Consolidated联合))', 'S:Self (Manifest Type(Consolidated))')
export const ENS_DECLARATION_A = new CommonState('A', 'A:Manifest Type(Simple简易) & Contained Actual Party Information(Shipper, Consignee)', 'A:Manifest Type(Simple) & Contained Actual Party Information(Shipper, Consignee)')
export const ENS_DECLARATION_B = new CommonState('B', 'B:Manifest Type(Simple简易) & Contained Actual Party Information(Shipper, Consignee)', 'B:Manifest Type(Simple) & Contained Actual Party Information(Shipper, Consignee)')
export const ENS_DECLARATION_N = new CommonState('N', 'N:Manifest Type(Simple简易) & non-Contained Actual Party', 'N:Manifest Type(Simple) & non-Contained Actual Party')
export const ENS_DECLARATION_C = new CommonState('C', 'C:Carrier (Manifest Type(Consolidated联合))', 'C:Carrier (Manifest Type(Consolidated))')

export const ENS_DECLARATION = [
  ENS_DECLARATION_S,
  ENS_DECLARATION_A,
  ENS_DECLARATION_B,
  ENS_DECLARATION_N,
  ENS_DECLARATION_C
]

export const ENS_DECLARATION_STRAIGHT_CARRIER = new CommonState('SC', 'Straight BL with Carrier Filing 直客单-HPL代发买卖方信息', 'Straight BL with Carrier Filing 直客单-HPL代发买卖方信息')
export const ENS_DECLARATION_STRAIGHT_SUPPLEMENTARY = new CommonState('SS', 'Straight BL with Supplementary Declarant for Seller and Buyer Filing 直客单-客户自发买卖方信息', 'Straight BL with Supplementary Declarant for Seller and Buyer Filing 直客单-客户自发买卖方信息')
export const ENS_DECLARATION_HOUSE_CARRIER = new CommonState('HC', 'House BL with Carrier Filing非直客单-HPL代发House bill&Seller&Buyer信息', 'House BL with Carrier Filing非直客单-HPL代发House bill&Seller&Buyer信息')
export const ENS_DECLARATION_HOUSE_SELF = new CommonState('HS', 'House BL with Self-Filer Code 非直客单-客户自发House bill&Seller&Buyer信息', 'House BL with Self-Filer Code 非直客单-客户自发House bill&Seller&Buyer信息')
export const ENS_DECLARATION_HOUSE_MIXED = new CommonState('HM', 'House BL with Mixed Filing 非直客单/混合模式-客户自发买卖方信息，HPL代发House bill', 'House BL with Mixed Filing 非直客单/混合模式-客户自发买卖方信息，HPL代发House bill')

export const ENS_DECLARATION_HPL = [
  ENS_DECLARATION_STRAIGHT_CARRIER,
  ENS_DECLARATION_STRAIGHT_SUPPLEMENTARY,
  ENS_DECLARATION_HOUSE_CARRIER,
  ENS_DECLARATION_HOUSE_SELF,
  ENS_DECLARATION_HOUSE_MIXED
]

/**
 * 舱单类型
 */
export const MANIFEST_TYPE_S = new CommonState('S', 'Simple', 'Simple')
export const MANIFEST_TYPE_C = new CommonState('C', 'Consolidated', 'Consolidated')

export const MANIFEST_TYPE = [
  MANIFEST_TYPE_S,
  MANIFEST_TYPE_C
]
